import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { GetAllPendingUsers } from "../../api's/settings";
import { useToken } from "../../common/helper";
import { GetMenu } from "../../api's/auth";
import testjson from '../../routes/permissionTestJSON.json';


// const menus = {
//     dashboard: {
//       key: "dashboard",
//       permissions: ["view"],
//       subMenu: [],
//     },
//     shipment: {
//       key: "shipment",
//       permissions: ["view", "add", "edit", "delete"],
//       subMenu: [],
//     },
//     airportList: {
//       key: "airport-list",
//       permissions: ["view"],
//       subMenu: [],
//     },
//     settings: {
//       key: "settings",
//       permissions: ["view"],
//       subMenu: {
//         profile: {
//           key: "profile",
//           permissions: ["view", "edit"],
//         },
//         product: {
//           key: "product",
//           permissions: ["view", "add", "edit", "delete"],
//         },
//         user: {
//           key: "user",
//           permissions: ["view", "add", "edit", "delete"],
//         },
//         location: {
//           key: "location",
//           permissions: ["view", "edit"],
//         },
//         roles: {
//           key: "roles",
//           permissions: ["view", "edit"],
//         },
//         team: {
//           key: "team",
//           permissions: ["view", "add", "edit"],
//         },
//         notification: {
//           key: "notification",
//           permissions: ["view", "edit", "delete"],
//         },
//         couriers: {
//           key: "couriers",
//           permissions: ["view", "add", "edit", "delete"],
//         },
//         sensor: {
//           key: "sensor",
//           permissions: ["view", "edit", "delete"],
//         },
//       },
//     },
//     chatbot: {
//       key: "chatbot",
//       permissions: ["view"],
//       subMenu: [],
//     },
//   };



  // const menus = [
  //   {
  //     id: "83d7f9ad-c647-4f10-b355-842ac56d9057",
  //     name: "Home",
  //     label: "Home",
  //     icon: "DashboardIcon",
  //     coloredIcon: "ColoredDashboardIcon",
  //     route: "dashboard",
  //     permissions: {
  //       is_create: true,
  //       is_update: true,
  //       is_delete: true,
  //       is_view: true,
  //     },
  //     sub_menus: [],
  //   },
  //   {
  //     id: "3181a723-80f9-4bb3-a904-cc6067d5e623",
  //     name: "Shipment",
  //     label: "Shipment",
  //     icon: "ShipmentIcon",
  //     coloredIcon: "ColoredShipmentIcon",
  //     route: "shipment",
  //     permissions: {
  //       is_create: true,
  //       is_update: true,
  //       is_delete: true,
  //       is_view: true,
  //     },
  //     sub_menus: [],
  //   },
  //   {
  //     id: "024662a4-9a2b-4fa3-8f81-02611f5f2083",
  //     name: "Airports",
  //     label: "Airports",
  //     icon: "FlyingIcon",
  //     coloredIcon: "ColoredFlyingIcon",
  //     route: "airport-list",
  //     permissions: {
  //       is_create: true,
  //       is_update: true,
  //       is_delete: true,
  //       is_view: true,
  //     },
  //     sub_menus: [],
  //   },
  //   {
  //     id: "81555651-d37f-40b9-bc49-7ed3231b2070",
  //     name: "Settings",
  //     label: "Settings",
  //     icon: "SettingsIcon",
  //     coloredIcon: "ColoredSettingsIcon",
  //     route: "settings",
  //     permissions: {
  //       is_create: true,
  //       is_update: true,
  //       is_delete: true,
  //       is_view: true,
  //     },
  //     sub_menus: [
  //       {
  //         id: "1a8c28d8-de18-4c0f-a38b-6abf21ed9ab9",
  //         name: "General",
  //         label: "General",
  //         route: "settings/profile",
  //         permissions: {
  //           is_create: true,
  //           is_update: true,
  //           is_delete: true,
  //           is_view: true,
  //         },
  //       },
  //       {
  //         id: "f4be5302-fd9a-4533-ba20-dd39de845977",
  //         name: "notifications",
  //         label: "notifications",
  //         route: "settings/notifications",
  //         permissions: {
  //           is_create: true,
  //           is_update: true,
  //           is_delete: true,
  //           is_view: true,
  //         },
  //       },
  //       {
  //         id: "c4e72804-e3c0-4746-8afc-384e973ee889",
  //         name: "Transport Providers",
  //         label: "Transport Providers",
  //         route: "settings/couriers",
  //         permissions: {
  //           is_create: true,
  //           is_update: true,
  //           is_delete: true,
  //           is_view: true,
  //         },
  //       },
  //       {
  //         id: "3ff136c0-99d5-469f-b27e-0b18cb30ebe3",
  //         name: "Products",
  //         label: "Products",
  //         route: "settings/product",
  //         permissions: {
  //           is_create: true,
  //           is_update: true,
  //           is_delete: true,
  //           is_view: true,
  //         },
  //       },
  //       {
  //         id: "7968ebe3-6b15-4ee1-a2f2-4f343f185de0",
  //         name: "Sensors",
  //         label: "Sensors",
  //         route: "settings/sensor",
  //         permissions: {
  //           is_create: true,
  //           is_update: true,
  //           is_delete: true,
  //           is_view: true,
  //         },
  //       },
  //       {
  //         id: "5785397e-0364-4390-a82a-10ce4a4bb7df",
  //         name: "Locations",
  //         label: "Locations",
  //         route: "settings/location",
  //         permissions: {
  //           is_create: true,
  //           is_update: true,
  //           is_delete: true,
  //           is_view: true,
  //         },
  //       },
  //       {
  //         id: "0535b588-8ed7-4e87-8ba4-49057ad54e53",
  //         name: "Teams",
  //         label: "Teams",
  //         route: "settings/team",
  //         permissions: {
  //           is_create: true,
  //           is_update: true,
  //           is_delete: true,
  //           is_view: true,
  //         },
  //       },
  //       {
  //         id: "15a18a7c-230f-4452-a06c-6a173ca18ec8",
  //         name: "Users",
  //         label: "Users",
  //         route: "settings/user",
  //         permissions: {
  //           is_create: true,
  //           is_update: true,
  //           is_delete: true,
  //           is_view: true,
  //         },
  //       },
  //       {
  //         id: "8e3d85e0-e6ce-4c5e-9d1a-d0c396b1fe7c",
  //         name: "Roles Permissions",
  //         label: "Roles Permissions",
  //         route: "settings/roles",
  //         permissions: {
  //           is_create: true,
  //           is_update: true,
  //           is_delete: true,
  //           is_view: true,
  //         },
  //       },
  //     ],
  //   },
  //   {
  //     id: "7a97ed6e-be19-480c-8101-9e78511d5a3c",
  //     name: "Chatbot",
  //     label: "Chatbot",
  //     icon: "chatIcon",
  //     coloredIcon: "ColoredChatbotIcons",
  //     route: "chatbot",
  //     permissions: {
  //       is_create: true,
  //       is_update: true,
  //       is_delete: true,
  //       is_view: true,
  //     },
  //     sub_menus: [],
  //   },
  // ];
  
   
  


  export const fetchMenu = createAsyncThunk("menu/fetchMenu", async (token, { rejectWithValue }) => {
    // return menus; // JSON array 
    // return testjson?.menus; // JSON array 

    try {
      const res = await GetMenu(token);
      const data = res?.data?.menus ? res?.data?.menus : null;
      if (data && res?.status == 200) {
        const menuItems = data?.length > 0 ? data : [];
        if (menuItems.length === 0) {
          return rejectWithValue("NO_MENU_ITEMS");
        }
        return menuItems;
      } else {
        return rejectWithValue("Failed to fetch menu: Success flag not true");
      }
    } catch (error) {
      console.error("Error fetching menu:", error);
      return rejectWithValue(error.response?.data?.message || "Failed to fetch menu");
    }
  });


const menuSlice = createSlice({
  name: "menu",
  initialState: {
    items: [],
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenu.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchMenu.fulfilled, (state, action) => {
        state.items = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchMenu.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export default menuSlice.reducer;
